import client from './client';

// Категории = родные группы 2ГИС (1:1 с 2gis.kz). Синхронизировано с
// 2gisparser/load_firms_2gis_native.py и app placeCategoryMeta.
export const DIRECTORY_CATEGORIES: Record<string, string> = {
  food_products: 'Продукты и напитки',
  medicine_beauty: 'Медицина и красота',
  leisure_food: 'Досуг и общепит',
  household_services: 'Бытовые услуги',
  business_finance: 'Юр., фин. и бизнес',
  auto: 'Авто',
  clothing: 'Одежда и обувь',
  education_work: 'Образование и работа',
  malls: 'Торговые комплексы',
  transport: 'Транспорт',
  government: 'Город и власть',
  construction: 'Строительство',
  sport_tourism: 'Спорт, отдых, туризм',
  fuel_chemistry: 'Топливо и химия',
  building_materials: 'Стройматериалы',
  it_telecom: 'Интернет и связь',
  household_goods: 'Хозтовары и канцелярия',
  textile: 'Текстиль и интерьер',
  media: 'Реклама и СМИ',
  culture_religion: 'Культура и религия',
  emergency: 'Экстренные службы',
  computers: 'Компьютеры и техника',
  equipment: 'Оборудование',
  security: 'Охрана и безопасность',
  furniture: 'Мебель',
  pets: 'Животные и ветеринария',
  electronics: 'Электроника',
  places: 'Места',
};

export interface DirectoryItem {
  id: number;
  name_kk: string;
  name_ru: string;
  category?: string;
  subcategory?: string;
  phone?: string;
  phone2?: string;
  address?: string;
  latitude?: number;
  longitude?: number;
  working_hours?: Record<string, string>;
  is_emergency: boolean;
  website?: string;
  rating?: number;
  source?: string;
  /** Логотип места (MinIO logos/), приложение подхватывает его в течение часа. */
  logo_url?: string | null;
}

export interface DirectoryCreate {
  name_kk: string;
  name_ru: string;
  category?: string;
  phone?: string;
  phone2?: string;
  address?: string;
  latitude?: number;
  longitude?: number;
  is_emergency?: boolean;
  website?: string;
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export const directoryApi = {
  list: (params?: { category?: string; search?: string; page?: number; size?: number }) =>
    client.get<PaginatedResponse<DirectoryItem>>('/api/admin/directory', { params }),

  create: (data: DirectoryCreate) =>
    client.post<DirectoryItem>('/api/admin/directory', data),

  update: (id: number, data: Partial<DirectoryCreate>) =>
    client.patch<DirectoryItem>(`/api/admin/directory/${id}`, data),

  delete: (id: number) =>
    client.delete(`/api/admin/directory/${id}`),

  // ── Логотипы (28.09.2026) ──
  uploadLogo: (id: number, file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return client.post<{ id: number; logo_url: string }>(`/api/admin/directory/${id}/logo`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  deleteLogo: (id: number) =>
    client.delete<{ id: number; logo_url: null }>(`/api/admin/directory/${id}/logo`),

  brands: (q?: string) =>
    client.get<{ items: BrandRow[] }>('/api/admin/directory/logos/brands', { params: { q: q || undefined, limit: 120 } }),

  setBrandLogo: (brand: string, file: File) => {
    const fd = new FormData();
    fd.append('brand', brand);
    fd.append('file', file);
    return client.post<{ brand: string; logo_url: string; updated: number }>('/api/admin/directory/logos/brand', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  candidates: (status: 'new' | 'accepted' | 'rejected' | 'all' = 'new') =>
    client.get<{ items: LogoCandidate[]; counts: Record<string, number>; updated?: number }>(
      '/api/admin/directory/logos/candidates', { params: { status } }),

  decideCandidate: (handle: string, decision: 'accept' | 'reject', brands?: string[]) =>
    client.post<{ handle: string; status: string; updated: number }>(
      `/api/admin/directory/logos/candidates/${encodeURIComponent(handle)}/${decision}`,
      null,
      { params: brands && brands.length ? { brands: brands.join('|') } : undefined },
    ),

  clearBrandLogo: (brand: string) =>
    client.delete<{ brand: string; updated: number }>('/api/admin/directory/logos/brand', { params: { brand } }),
};

/** Бренд = название до первой запятой; строка страницы «Логотипы». */
export interface BrandRow {
  brand: string;
  title: string;
  total: number;
  with_logo: number;
  logo_url?: string | null;
  instagram?: string | null;
}

/** Кандидат в логотипы: картинка профиля Instagram, ждёт решения человека. */
export interface LogoCandidate {
  handle: string;
  /** Откуда картинка: «@handle», «App Store · …», «сайт …». */
  label?: string;
  status: 'new' | 'accepted' | 'rejected';
  instagram?: string;
  url: string;
  total: number;
  brands: { brand: string; title: string; total: number }[];
}
